// extracted by mini-css-extract-plugin
module.exports = {"boxLeftx":"dev_boxLeftx__1lDNT","boxRightx":"dev_boxRightx__3bwPk"};